export const facetableFields = [
  "company",
  "department",
  "location",
  "schedule",
  "work_mode",
  "start_year",
  "career_level",
  "working_hours",
  "salary",
  "country",
  "cluster",
  "contract_type",
  "custom_filter_1",
  "custom_filter_2",
  "custom_filter_3",
  "custom_filter_4",
  "custom_filter_5",
  "custom_filter_6",
];
